import React from 'react';
import { Beer, Heart, MapPin, Users } from 'lucide-react';

function AboutUs() {
  return (
    <div className="min-h-screen bg-dive-black p-6">
      <div className="max-w-lg mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-2xl font-display text-white">About Tilted</h1>
        </div>

        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src="/logo-nameplate.png" 
            alt="Tilted" 
            className="h-16 mx-auto mb-4"
          />
          <p className="text-dive-amber font-medium">The Dive Bar Community App</p>
        </div>

        {/* Mission */}
        <div className="bg-dive-dark rounded-xl border border-dive-gray p-6 mb-6">
          <h2 className="text-white font-display text-xl mb-4 flex items-center gap-2">
            <Beer className="w-5 h-5 text-dive-amber" />
            Our Mission
          </h2>
          <p className="text-gray-300 leading-relaxed">
            Tilted was born from a simple idea: help people discover the hidden gems that make 
            a city's bar scene legendary. We're building a community of dive bar enthusiasts 
            who appreciate the charm of a well-worn barstool, a cold beer, and great conversation.
          </p>
          <p className="text-gray-300 leading-relaxed mt-4">
            We're based in Chicago, and its dive bars are what inspired all of this: the corner
            taverns, the Old Style signs, the jukeboxes that haven't been updated since the '80s.
            But every city has its own version of that bar, and we think they all deserve a spot
            on the map. We're starting with a pilot in a few cities for now before expanding
            everywhere.
          </p>
        </div>

        {/* Features */}
        <div className="grid grid-cols-1 gap-4 mb-8">
          <div className="bg-dive-dark rounded-xl border border-dive-gray p-4 flex items-start gap-4">
            <div className="w-10 h-10 rounded-lg bg-dive-neon/20 flex items-center justify-center flex-shrink-0">
              <MapPin className="w-5 h-5 text-dive-neon" />
            </div>
            <div>
              <h3 className="text-white font-medium mb-1">Discover</h3>
              <p className="text-gray-400 text-sm">Find dive bars near you with our curated map of the best spots in your city.</p>
            </div>
          </div>

          <div className="bg-dive-dark rounded-xl border border-dive-gray p-4 flex items-start gap-4">
            <div className="w-10 h-10 rounded-lg bg-dive-amber/20 flex items-center justify-center flex-shrink-0">
              <Heart className="w-5 h-5 text-dive-amber" />
            </div>
            <div>
              <h3 className="text-white font-medium mb-1">Rate & Review</h3>
              <p className="text-gray-400 text-sm">Share your experiences and help others find their new favorite spot.</p>
            </div>
          </div>

          <div className="bg-dive-dark rounded-xl border border-dive-gray p-4 flex items-start gap-4">
            <div className="w-10 h-10 rounded-lg bg-purple-500/20 flex items-center justify-center flex-shrink-0">
              <Users className="w-5 h-5 text-purple-400" />
            </div>
            <div>
              <h3 className="text-white font-medium mb-1">Connect</h3>
              <p className="text-gray-400 text-sm">Follow friends, see their ratings, and discover bars together.</p>
            </div>
          </div>
        </div>

        {/* Contact */}
        <div className="text-center text-gray-500 text-sm">
          <p className="mb-2">Born in Chicago. Built for dive bars everywhere.</p>
          <p>Questions? Reach out at <a href="mailto:gettiltedapp@gmail.com" className="text-dive-neon hover:underline">gettiltedapp@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
